export * from './LocationResultsListsV2SM';
export * from './LocationResultsListsV2XS';
